<template>
  <div class="border">
    <list :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true"
      :isAdd="true" :itemLink="itemLink" :setLink="setLink" :openItem="false" :fields="fields" :params="params"
      :searchDisable="true" @change="change" @changeFunction="changeFunction" v-model="val" />
  </div>


</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  props: ['id'],
  created() {
    this.itemLink += `/${this.id}/variants`;
    this.setLink += `/${this.id}/variants`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: ' col-12 col-md-12',
          key: "variants",
          label: "Выберите товары",
          type: "selects",
          modal: 'variant',
          selectKey: 'name'
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_conditional",
      itemLink: "promotions",
      setLink: "promotions",
      columns: [

        {
          key: "name",
          title: "Товар",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "barcode",
          title: "Баркод",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          // detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
